import { Menu, useMantineTheme } from '@mantine/core';
import {
  IconBrandInstagram,
  IconBrandTwitter,
  IconBrandYoutube,
  IconBug,
  IconChevronUp,
  IconGlobe,
  IconLock,
  IconMessage,
  IconMoneybag,
  IconPlug,
  IconQuestionMark,
  IconTextGrammar,
} from '@sloyd/icons';
import { Button } from '../Button/Button';
import { Wrapper } from './ExtraButton.style';

export type ExtraButtonProps = {
  onNavigate: (path: string) => void;
};

export function ExtraButton(props: ExtraButtonProps) {
  const theme = useMantineTheme();

  return (
    <Wrapper className='ExtraButton-wrapper' data-testid='ExtraButton-wrapper'>
      <Menu
        transitionProps={{ transition: 'pop-top-right' }}
        position='top-end'
        width={220}
        withinPortal
      >
        <Menu.Target>
          <Button variant='subtle' rightSection={<IconChevronUp size={18} stroke={1.5} />} pr={12}>
            Resources
          </Button>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item
            leftSection={<IconGlobe />}
            onClick={() => props.onNavigate('https://sloyd.ai/')}
          >
            Website
          </Menu.Item>
          <Menu.Item
            leftSection={<IconBrandTwitter />}
            onClick={() => props.onNavigate('https://x.com/sloydai')}
          >
            Twitter/X
          </Menu.Item>
          <Menu.Item
            leftSection={<IconBrandYoutube />}
            onClick={() => props.onNavigate('https://www.youtube.com/@SloydAI')}
          >
            Youtube
          </Menu.Item>
          <Menu.Item
            leftSection={<IconBrandInstagram />}
            onClick={() => props.onNavigate('https://www.instagram.com/sloydai/')}
          >
            Instagram
          </Menu.Item>
          <Menu.Divider></Menu.Divider>

          <Menu.Item
            leftSection={<IconMoneybag />}
            onClick={() => props.onNavigate('https://sloyd.ai/pricing')}
          >
            Pricing
          </Menu.Item>
          <Menu.Item
            leftSection={<IconPlug />}
            onClick={() => props.onNavigate('https://sloyd.ai/api')}
          >
            API
          </Menu.Item>
          <Menu.Item
            leftSection={<IconLock />}
            onClick={() => props.onNavigate('https://sloyd.ai/privacy-policy')}
          >
            Privacy Policy
          </Menu.Item>
          <Menu.Item
            leftSection={<IconTextGrammar />}
            onClick={() => props.onNavigate('https://sloyd.ai/terms-of-use')}
          >
            Terms of Use
          </Menu.Item>
          <Menu.Divider></Menu.Divider>
          <Menu.Item
            leftSection={<IconMessage />}
            onClick={() => props.onNavigate('https://survey.typeform.com/to/whHwt0PS')}
          >
            Give Feedback
          </Menu.Item>
          <Menu.Item
            leftSection={<IconBug />}
            onClick={() => props.onNavigate('https://survey.typeform.com/to/gRI5gwEU')}
          >
            Report a Bug
          </Menu.Item>
          <Menu.Item
            leftSection={<IconQuestionMark />}
            onClick={() => props.onNavigate('https://survey.typeform.com/to/MveoeAXF ')}
          >
            Feature Request
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </Wrapper>
  );
}

export default ExtraButton;
